import type { ImgHTMLAttributes } from "react";
import iconUrl from "@/assets/icon.svg";
import logoUrl from "@/assets/logo.svg";

export type LogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

/**
 * Travel Connection Spain wordmark (gold mark + name). Size it with CSS height — the SVG
 * keeps its aspect ratio. Used on the login page and the site header.
 */
export function Logo({ className, ...props }: LogoProps) {
  return <img src={logoUrl} alt="Travel Connection Spain" className={className} {...props} />;
}

/**
 * The mark only (gold comet), no wordmark — for tight spots like a collapsed sidebar or
 * a favicon-sized slot. Decorative by default (paired with visible text elsewhere).
 */
export function LogoIcon({ className, ...props }: LogoProps) {
  return <img src={iconUrl} alt="" aria-hidden className={className} {...props} />;
}
